import { UIUserInfo, UIPrefillTraveller } from "@flights/types";

export type State = { userInfo?: UIUserInfo; travellers?: UIPrefillTraveller[] };

export const getInitialState = (): State => ({});
